import React, { useMemo } from 'react'
import { CloseIcon } from '../../assets/icons/CloseIcon'
import { ModalSizes } from '../../libraries/ModalSize'
import { getMergedClassNames, getUniqueKey } from '../../utils/HTMLutils'
import Button, { ButtonProps } from '../button/Button'
import IconButton from '../iconButton/IconButton'
import './Modal.scss'
const rootClassName = 'component-modal'

export interface ModalProps {
  id?: string
  className?: string
  modalKey?: string | number
  title?: string
  preventEscExit?: boolean
  preventMaskExit?: boolean
  onClose?: (modalKey?: string | number) => void
  size?: ModalSizes
  mobileOnXS?: boolean
  footer?: any | ButtonProps[]
  children?: any
}

export default function Modal(props: ModalProps) {
  const filteredProps = useMemo(() => {
    const p: any = {
      ...props,
      id: props.id
        ? props.id
        : props.modalKey
        ? props.modalKey
        : `modal${getUniqueKey()}`,
      className: getMergedClassNames([
        rootClassName,
        props.className || '',
        props.mobileOnXS ? 'mobile-on-xs' : '',
        `${rootClassName}-${String(props.size).toLowerCase()}`
      ])
    }
    delete p.footer
    delete p.title
    delete p.onClose
    delete p.onConfirm
    delete p.onCancel
    delete p.size
    delete p.mobileOnXS
    delete p.preventEscExit
    delete p.preventMaskExit
    delete p.modalKey
    return p
  }, [props])

  const footer = useMemo(() => {
    if (!props.footer) return null
    if (Array.isArray(props.footer)) {
      return props.footer.map((props, index) => {
        return <Button key={index} {...props} />
      })
    }
    return props.footer
  }, [props.footer])

  const handleClose = () => {
    props.onClose!(props.modalKey)
  }

  return (
    <div {...filteredProps}>
      <div className={`${rootClassName}-header`}>
        <div className={`${rootClassName}-title`}>{props.title}</div>
        <div className={`${rootClassName}-close-button`}>
          <IconButton onClick={handleClose} icon={<CloseIcon />} />
        </div>
      </div>
      <div className={`${rootClassName}-content`}>{props.children}</div>
      {props.footer ? (
        <div className={`${rootClassName}-footer`}>{footer}</div>
      ) : undefined}
    </div>
  )
}

Modal.defaultProps = {
  title: 'Title',
  onClose: () => {},
  size: 'large'
}
